// tr strings for messages/library.ts. Same keys and {variables} as en there.
// Category names (library.cat.* / library.lang.*) are nouns that work before
// "sesleri" ("yapay zeka anime sesleri", "yapay zeka Japonca sesleri"),
// lower-case mid-sentence; categoryLabel() capitalises them for pills. Words
// that would start with "i" keep a capital "İ" (JS toUpperCase gives "I").
import type { Dict } from "../index";

const library: Dict = {
  "library.of": "{name}",
  "library.ofLanguage": "{name}",

  "library.seo.title": "Yapay zeka ses kütüphanesi{filter} | Jammable",
  "library.seo.titleFiltered":
    "Yapay zeka ses kütüphanesi: {filter} | Jammable",
  "library.seo.description":
    "93.000+ yapay zeka ses modeline göz at. Anime, oyun, çizgi film, K-pop ve daha fazlasından seslerle AI cover yap. Her gün yeni sesler ekleniyor.",
  "library.seo.ogDescription":
    "93.000+ yapay zeka ses modeline göz at. Anime, oyun, çizgi film, K-pop ve daha fazlasından seslerle AI cover yap.",
  "library.seo.listDescription":
    "Jammable yapay zeka sesleri. AI cover şarkı yapıcı. Metinden sese. En gelişmiş yapay zeka teknolojisi. 50.000+ AI cover sesi.",
  "library.seo.listDescriptionFiltered":
    "Yapay zeka sesleri: {filter}. AI cover şarkı yapıcı ({filter}). Metinden sese. En gelişmiş yapay zeka teknolojisi. 50.000+ AI cover sesi.",
  "library.crumb.home": "Ana sayfa",
  "library.crumb.library": "Yapay zeka ses kütüphanesi",
  "library.crumb.filter": "Yapay zeka {category} sesleri",

  "library.title": "Ses kütüphanesi",
  "library.subtitle":
    "93.000+ ses. Dinlemek için birine dokun ya da hemen cover yap.",
  "library.train": "Kendi sesini eğit",
  "library.search": "Ses ara",
  "library.searchIn": "Ara: {categoryLower} sesleri",
  "library.categoriesNav": "Ses kategorileri",
  "library.all": "Tümü",
  "library.moreCategories": "Daha fazla kategori",
  "library.fewerCategories": "Daha az kategori",
  "library.collections": "Koleksiyonlar",
  "library.collections.prev": "Önceki koleksiyonlar",
  "library.collections.next": "Daha fazla koleksiyon",
  "library.collection.voices": "{n} ses",
  "library.voicesIn": "Yapay zeka {category} sesleri",
  "library.allVoices": "Tüm sesler",
  "library.empty.title": "Ses bulunamadı",
  "library.empty.body": "Başka bir isim dene ya da sesi kendin eğit.",
  "library.loadMore": "Daha fazla ses yükle",

  "library.sort.aria": "Sesleri sırala",
  "library.sort.hot": "Bugün trend olanlar",
  "library.sort.hot.short": "Trend",
  "library.sort.top": "En çok kullanılanlar",
  "library.sort.top.short": "En çok kullanılan",
  "library.sort.liked": "En çok beğenilenler",
  "library.sort.liked.short": "En beğenilen",
  "library.sort.new": "En yeniler",
  "library.sort.new.short": "En yeni",

  "library.hub.title":
    "Yapay zeka {category} sesleri: {category} sesleriyle AI cover yap | Jammable",
  "library.hub.titlePage":
    "Yapay zeka {category} sesleri, sayfa {page} | Jammable",
  "library.hub.description":
    "Jammable'da {count}+ yapay zeka {category} sesine göz at. AI cover yapmak ya da yapay zeka ses değiştiriciyi kullanmak için bir ses seç.",
  "library.hub.descriptionPage":
    "Jammable'daki yapay zeka {category} sesleri, sayfa {page} / {lastPage}, kullanıma göre sıralı. AI cover yapmak ya da yapay zeka ses değiştiriciyi kullanmak için bir ses seç.",
  "library.hub.name": "Yapay zeka {category} sesleri",
  "library.hub.crumbVoices": "Yapay zeka sesleri",
  "library.hub.voices": "Sesler",
  "library.hub.page": "Sayfa {page}",
  "library.hub.h1": "Yapay zeka {category} sesleri",
  "library.hub.intro":
    "{count}+ yapay zeka {category} sesine göz at. AI cover yapmak için birini seç ya da ses değiştirici olarak kullan.",
  "library.hub.popular": "Popüler {categoryLower} sesleri",
  "library.hub.mostUsedPage":
    "En çok kullanılan {categoryLower} sesleri, sayfa {page} / {lastPage}",
  "library.hub.noMatch":
    "Bu aramayla eşleşen ses yok (kategori: {categoryLower}).",
  "library.hub.openLibrary": "Ses kütüphanesinde aç",
  "library.hub.moreCategories": "Daha fazla kategori keşfet",
  "library.hub.faq": "Sık sorulan sorular",
  "library.hub.keepExploring": "Keşfetmeye devam et",
  "library.hub.moreWays": "Jammable ile üretmenin daha fazla yolu.",
  "library.hub.link.aiCover": "AI cover oluşturucu",
  "library.hub.link.voiceChanger": "Yapay zeka ses değiştirici",
  "library.hub.link.allVoices": "Tüm yapay zeka seslerine göz at",
  "library.hub.pages": "Sayfalar",
  "library.hub.first": "İlk",
  "library.hub.prev": "Önceki",
  "library.hub.next": "Sonraki",
  "library.hub.last": "Son",
  "library.hub.faq1.q": "Yapay zeka {category} sesleri nedir?",
  "library.hub.faq1.a":
    "Yapay zeka {category} sesleri, {categoryLower} kategorisindeki ses modelleridir; bunlarla AI cover yapabilir ya da kendi sesini değiştirebilirsin. Jammable'da bu kategoride {count}+ ses var ve her gün yenileri ekleniyor.",
  "library.hub.faq2.q": "Yapay zeka {category} sesi nasıl kullanılır?",
  "library.hub.faq2.a":
    "Herhangi bir {category} sesini aç, kullanım hakkına sahip olduğun bir ses dosyası ekle (ya da kendi sesini kaydet) ve oluştur'a bas. Jammable vokalleri o sese dönüştürür ve bitmiş cover'ı saniyeler içinde sana verir.",
  "library.hub.faq3.q": "Kaç tane {category} sesi var?",
  "library.hub.faq3.a":
    "Jammable'da şu anda {count}+ yapay zeka {category} sesi var ve topluluk yeni sesler yükleyip eğittikçe kütüphane her gün büyüyor.",

  "library.cat.public-figure": "ünlü",
  "library.cat.music": "müzik",
  "library.cat.cartoon": "çizgi film",
  "library.cat.gaming": "oyun",
  "library.cat.fictional": "kurgusal karakter",
  "library.cat.anime": "anime",
  "library.cat.influencer": "influencer",
  "library.cat.singer": "şarkıcı",
  "library.cat.comedy": "komedi",
  "library.cat.pop": "pop",
  "library.cat.youtuber": "YouTuber",
  "library.cat.tv-show": "dizi",
  "library.cat.rap": "rap",
  "library.cat.fictional-character": "kurgusal karakter",
  "library.cat.movie": "film",
  "library.cat.movies": "film",
  "library.cat.funny": "mizah",
  "library.cat.kpop": "K-pop",
  "library.cat.k-pop": "K-pop",
  "library.cat.parody": "parodi",
  "library.cat.animation": "animasyon",
  "library.cat.animated": "animasyon",
  "library.cat.rock": "rock",
  "library.cat.vtuber": "VTuber",
  "library.cat.fantasy": "fantastik karakter",
  "library.cat.game": "oyun",
  "library.cat.entertainment": "eğlence",
  "library.cat.rapper": "rapçi",
  "library.cat.horror": "korku",
  "library.cat.actor": "oyuncu",
  "library.cat.actors": "oyuncu",
  "library.cat.actress": "kadın oyuncu",
  "library.cat.meme": "mim",
  "library.cat.action": "aksiyon",
  "library.cat.educational": "eğitim",
  "library.cat.hip-hop-rap": "hip-hop/rap",
  "library.cat.hip-hop": "hip-hop",
  "library.cat.adventure": "macera",
  "library.cat.tv": "TV",
  "library.cat.female": "kadın",
  "library.cat.male": "erkek",
  "library.cat.superhero": "süper kahraman",
  "library.cat.drama": "dram",
  "library.cat.sci-fi": "bilim kurgu",
  "library.cat.science-fiction": "bilim kurgu",
  "library.cat.alternative": "alternatif müzik",
  "library.cat.metal": "metal",
  "library.cat.technology": "teknoloji",
  "library.cat.indie": "indie",
  "library.cat.celebrity": "ünlü",
  "library.cat.fiction": "kurgu",
  "library.cat.american": "Amerikan",
  "library.cat.british": "İngiliz",
  "library.cat.australian": "Avustralya",
  "library.cat.latino": "Latin",
  "library.cat.mexico": "Meksika",
  "library.cat.villain": "kötü karakter",
  "library.cat.politics": "siyaset",
  "library.cat.president": "başkan",
  "library.cat.animal": "hayvan",
  "library.cat.animals": "hayvan",
  "library.cat.dog": "köpek",
  "library.cat.cat": "kedi",
  "library.cat.sports": "spor",
  "library.cat.wrestling": "güreş",
  "library.cat.streamer": "yayıncı",
  "library.cat.country": "country",
  "library.cat.robot": "robot",
  "library.cat.sound-effects": "ses efekti",
  "library.cat.historical": "tarihi figür",
  "library.cat.folk": "folk",
  "library.cat.r-b": "R&B",
  "library.cat.rnb": "R&B",
  "library.cat.jazz": "caz",
  "library.cat.reggaeton": "reggaeton",
  "library.cat.electronic": "elektronik müzik",
  "library.cat.pop-music": "pop müzik",
  "library.cat.comic": "çizgi roman",
  "library.cat.demon": "iblis",
  "library.cat.news": "haber",
  "library.cat.artist": "sanatçı",
  "library.cat.artistas": "sanatçı",
  "library.cat.cantantes": "şarkıcı",
  "library.cat.cantante": "şarkıcı",
  "library.cat.personajes": "karakter",
  "library.cat.character": "karakter",
  "library.cat.singing": "şarkı",
  "library.cat.mystery": "gizem",
  "library.cat.christmas": "Noel",
  "library.cat.sitcom": "sitcom",
  "library.cat.pirate": "korsan",
  "library.cat.toy": "oyuncak",
  "library.cat.classic": "klasik",
  "library.cat.art": "sanat",
  "library.cat.poetry": "şiir",
  "library.cat.food": "yemek",
  "library.cat.fashion": "moda",
  "library.cat.family": "aile",
  "library.cat.podcast": "podcast",
  "library.cat.radio": "radyo",
  "library.cat.ai": "AI",
  "library.cat.artificial-intelligence": "AI",
  "library.cat.song": "şarkı",
  "library.cat.ringtone": "zil sesi",
  "library.cat.web-series": "web dizisi",
  "library.cat.idol": "İdol",
  "library.cat.dub": "dublaj",
  "library.cat.80s": "80'ler",
  "library.cat.indie-games": "bağımsız oyun",
  "library.cat.game-show": "yarışma programı",
  "library.lang.japanese": "Japonca",
  "library.lang.japenese": "Japonca",
  "library.lang.korean": "Korece",
  "library.lang.spanish": "İspanyolca",
  "library.lang.english": "İngilizce",
  "library.lang.french": "Fransızca",
  "library.lang.italian": "İtalyanca",
  "library.lang.german": "Almanca",
  "library.lang.deutsch": "Almanca",
  "library.lang.russian": "Rusça",
  "library.lang.hebrew": "İbranice",
  "library.lang.chinese": "Çince",
  "library.lang.arabic": "Arapça",
  "library.lang.swedish": "İsveççe",
  "library.lang.polish": "Lehçe",
  "library.lang.turkish": "Türkçe",
  "library.lang.finnish": "Fince",
  "library.lang.greek": "Yunanca",
  "library.lang.indonesian": "Endonezce",
  "library.lang.thai": "Tayca",
  "library.lang.hungarian": "Macarca",
  "library.lang.filipino": "Filipince",
  "library.lang.malaysian": "Malayca",
  "library.lang.portuguese": "Portekizce",
  "library.lang.brasileiro": "Brezilya Portekizcesi",
  "library.lang.pt-br": "Brezilya Portekizcesi",
  "library.lang.romanian": "Rumence",
  "library.lang.hindi": "Hintçe",
  "library.lang.dutch": "Felemenkçe",
  "library.lang.czech": "Çekçe",
  "library.lang.vietnamese": "Vietnamca",
};

export default library;
